import { renderFloat } from '@/utils/fn';
import { jumpToPageByH5 } from '@/utils/fn';
import styles from '../index.less';

const IncomeSummary = ({ pageName, cash, cloudBean }) => {
  return (
    <div className={styles.incomeSummaryCont}>
      <div className={styles.cash}>
        <span className={styles.cName}>现金（元）</span>
        <p className={styles.cVal}>{renderFloat(cash)}</p>
      </div>
      <span className={styles.line}></span>
      <div
        onClick={() => {
          // 收益明细页面-累计云豆
          if (pageName === 'group_income') {
            jumpToPageByH5('/wxMall/home');
          }
        }}
        className={styles.cloudBean}
      >
        <span className={styles.cName}>云豆（个）</span>
        <p className={styles.cVal}>{renderFloat(cloudBean, 0)}</p>
        {cloudBean > 0 && (
          <p className={styles.cloudBeanEquel}>≈{renderFloat(cloudBean / 100)}元</p>
        )}
      </div>
    </div>
  );
};
export default IncomeSummary;
